import { render, staticRenderFns } from "./userRetention.vue?vue&type=template&id=32fccb41&scoped=true"
import script from "./userRetention.vue?vue&type=script&lang=js"
export * from "./userRetention.vue?vue&type=script&lang=js"
import style0 from "./userRetention.vue?vue&type=style&index=0&id=32fccb41&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fccb41",
  null
  
)

export default component.exports